// Module
var code = `<div class="loan-preview">
  <div id="uid-accordion" class="accordion amortization-accordion">
    <table class="table">
      <thead>
      <tr>
        <th>Line no</th>
        <th>Amortization date</th>
        <th>Amortization amount</th>
        <th>Amortization balance</th>
        <th>Check date</th>
        <th>Check amount</th>
        <th>MICR</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody class="tbody">
      <tr
        ng-repeat-start="item in \$ctrl.pdcList | orderBy: 'amortizationNo'"
        class="table__row--clickable"
        ng-click="\$ctrl.displayPdcDetails(item, \$event)"
        ng-class="{'selected': \$ctrl.selectedPdcId == item.id}">
        <td>{{item.amortizationNo}}</td>
        <td>{{item.amortizationDueDate | prettyDate}}</td>
        <td>{{item.amortization.amortizationAmount | nxCurrency}}</td>
        <td>{{item.amortization.amortizationBalance | nxCurrency}}</td>
        <td>{{item.validFrom | prettyDate}}</td>
        <td>{{item.amount | nxCurrency}}</td>
        <td>{{item.micrNumber}}</td>
        <td ng-class="\$ctrl.getStatusStyle(item.status)">{{item.status | prettyEnum}}</td>
      </tr>

      <tr ng-repeat-end class="table__row--not-hoverable">
        <td colspan="100%">
          <div class="toggleable-panel-wrapper"
               ng-class="{'toggleable-panel-wrapper--toggled': item.id === \$ctrl.selectedPdcId}">
            <loan-pdc-tab-details
              on-hide="\$ctrl.hidePdcDetails()"
              loan="\$ctrl.loan"
              pdc-details="item"
              on-cancel="\$ctrl.onCancel()"
              on-post="\$ctrl.onPost()"
              on-postpone="\$ctrl.onPostpone()">
            </loan-pdc-tab-details>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <modal on-api-ready="\$ctrl.onCancelModalReady" form="\$ctrl.cancelForm">
    <modal-header><h2>Confirm action</h2></modal-header>
    <modal-body>
      <ng-form name="\$ctrl.cancelForm">
        <label>
          <span>Reason:</span>
          <input ng-model="\$ctrl.cancelRemarks" type="text" required/>
        </label>
      </ng-form>
    </modal-body>
  </modal>

  <modal on-api-ready="\$ctrl.onPostModalReady" form="\$ctrl.postForm">
    <modal-header>
      <h2>Confirm action</h2>
    </modal-header>
    <modal-body>
      <ng-form name="\$ctrl.postForm">
        <table class="table">
          <tr>
            <td>Invoice:</td>
            <td>
              <input ng-model="\$ctrl.postRequest.officialReceipt"
                       type="text"
                       ng-required="\$ctrl.autoReceiptEnabled"
                       ng-disabled="\$ctrl.autoReceiptEnabled"/>
              <div class="alert alert--danger" ng-if="\$ctrl.displayEmptyReceiptMessage">
                <span>User has no available invoice</span>
              </div>
            </td>
          </tr>
          <tr ng-if="!\$ctrl.autoReceiptEnabled">
            <td>Temporary Invoice:</td>
            <td><input ng-model="\$ctrl.postRequest.temporaryReceipt" type="text"/></td>
          </tr>
        </table>
      </ng-form>
    </modal-body>
  </modal>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pdc/tab/loan-pdc-tab.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;